export default {"id":"2e31f8d5","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}